import React from 'react';
import LimitTableFilter from '../../../components/limit/LimitTableFilter';
import styled from 'styled-components';

function ExpectedDividendLimitTable({ isRegion }: { isRegion?: boolean }) {
  return (
    <LimitTableFilter title="예상 배당표는" isRegion={isRegion}>
      <DateWrapper>
        <DateBox>
          <DateContent isFirst={true}>배당표 작성일</DateContent>
          <DateContent isFirst={false}>2025. 06. 13. 오전 09:00:00</DateContent>
        </DateBox>
        <DateBox>
          <DateContent isFirst={true}>입찰예상가</DateContent>
          <DateContent isFirst={false}>108,500,000 원</DateContent>
        </DateBox>
      </DateWrapper>
    </LimitTableFilter>
  );
}

export default ExpectedDividendLimitTable;

interface DateProps {
  isFirst: boolean;
}

const DateContent = styled.div<DateProps>`
  padding: 10px 12px;
  width: 100%;
  color: #616161;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 18.85px;
  word-wrap: break-word;
  display: flex;
  justify-content: center;
  background-color: ${({ isFirst }) => (isFirst ? '#f7f8fc' : 'white')};
  font-size: ${({ isFirst }) => (isFirst ? '13px' : '14px')};
`;

const DateBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #e8e9ea;
  border-bottom: 1px solid #e8e9ea;
  &:last-child {
    border-right: none;
  }
`;

const DateWrapper = styled.div`
  display: flex;
  flex-direction: row;
  border-top: 1px solid #222;
`;
